import type { PiniaPluginContext } from 'pinia'
import { useRouter } from 'vue-router'

export const routerPlugin = (context: PiniaPluginContext) => {
  const router = useRouter()
  context.store.router = router
}
